import Layout from "@/layout";

export default {
  path: "/beta-account",
  component: Layout,
  redirect: "/beta-account/extend",
  hidden: true,
  children: [
    {
      path: 'extend',
      name: 'ExtendAccountTime',
      component: () => import(/* webpackChunkName: "extendAccountTime" */ "@/views/beta/extend")
    },
    {
      path: 'reactive',
      name: 'BetaAccountReactive',
      component: () => import(/* webpackChunkName: "betaAccountReactive" */ "@/views/beta/reactive")
    }
  ]
}